import { makePost, makeDelete, makePut } from './ServiceManager';

export const saveUploadedAsset = async (assetData) => {
  const result = await makePost('service/asset/asset', assetData);
  return result;
};

export const removeAsset = async (assetData) => {
  const result = await makeDelete('service/asset/asset', assetData);
  return result;
};

export const updateAssetTags = async (assetId, tags) => {
  const result = await makePut('service/asset/tags', { assetId, tags });
  return result;
};

export const updateAssetThumbnailUrl = async (
  assetId,
  videoId,
  thumbnailUrl
) => {
  const result = await makePut('service/asset/thumbnail', {
    assetId,
    videoId,
    thumbnailUrl
  });
  return result;
};



// WEBPACK FOOTER //
// ./src/services/UploadAssetManager.js